<script>
import { bankView } from '../../../config/navigation'

const operations = {
  OPERATION_EDITING: 'editing',
  OPERATION_SETTLEMENT: 'settlement',
  OPERATION_ADJUSTMENT: 'adjustment'
}

export default {
  props: {
    bank: {
      type: Object,
      required: true
    },
    backend: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    navigation() {
      return bankView.map((o) => (Object.assign(o, {route: this.backend ? o.route.backend : o.route.report })))
    },
    current() {
      return this.getRoute()
    }
  },
  data: () => ({
    ...operations,
    operation: null
  })
}
</script>
<template>
  <div>
    <a-page-header :ghost="false" :title="`[${bank.bank_code}] ${bank.bank_name}`">
      <template #extra>
        <a-space size="large">
          <a-button icon="reconciliation" @click="() => operation = OPERATION_SETTLEMENT">Settlement</a-button>
          <a-button icon="column-width" @click="() => operation = OPERATION_ADJUSTMENT">Adjustment</a-button>
          <a-button icon="edit" type="primary" @click="() => operation = OPERATION_EDITING">Edit</a-button>
        </a-space>
      </template>

      <template #tags>
        <a-tag>{{ bank.bank_swift }}</a-tag>
      </template>

      <a-row type="flex" justify="space-between">
        <h4>
          <a-icon type="contacts" /> <strong>{{ bank.account_holder }}</strong>
          <br>
          <a-icon type="number" /> <code>{{ bank.account_number }}</code>
          <br>
          <a-icon type="global" /> <code>{{ bank.branch_name }}</code>
        </h4>

        <a-statistic :value="bank.balance" :value-style="{ color: bank.balance >= 0 ? '#237804' : '#a8071a'}">
          <template #suffix>IDR</template>
        </a-statistic>
      </a-row>

      <template #footer>
        <a-menu mode="horizontal" :selected-keys="[ current ]">
          <a-menu-item v-for="item in navigation" :key="item.route">
            <a :href="routeUri(item.route, { bank_hash: bank.hash })">
              <a-icon :type="item.icon"/>
              {{ item.text }}
            </a>
          </a-menu-item>
        </a-menu>
      </template>
    </a-page-header>

    <a-drawer :width="720" placement="right" :closable="true" :visible="operation != null" @close="() => operation = null">
      <template v-if="operation === OPERATION_EDITING">
        <h-bank-form :bank="bank" />
      </template>
      <template v-else-if="operation === OPERATION_ADJUSTMENT">
        <h-finance-adjustment-form :bank="bank" @close="() => operation = null"/>
      </template>
      <template v-else-if="operation === OPERATION_SETTLEMENT">
        <h-finance-settlement-form :bank="bank" @close="() => operation = null"/>
      </template>
    </a-drawer>
  </div>
</template>
